import script from "./Items.vue?vue&type=script&setup=true&lang=js"
export * from "./Items.vue?vue&type=script&setup=true&lang=js"

import "./Items.vue?vue&type=style&index=0&id=a8ccc4b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8ccc4b2"]])

export default __exports__